import { SVGProps } from "react";

export const Search1Icon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg width={size} height={size} {...rest} fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        d="m14.2 17.1 3.2 6 1.9 0.4 0.7 -1.8 -3.2 -6 2.7 -1.4V4.8l-8 -4.3 -8 4.3v9.5l8 4.2 2.7 -1.4Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M17.5 6v7l-6 3.2 -6 -3.2 12 -7Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m19.5 14.3 -8 4.2 -8 -4.2V4.8l8 -4.3 8 4.3v9.5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M5.5 13V6l6 -3.2 6 3.2v7l-6 3.2 -6 -3.2Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m14.2 17.1 3.2 6 1.9 0.4 0.7 -1.8 -3.2 -6"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m17.7702 17.5192 -2.5935 1.4121"
        strokeWidth={strokeWidth}
      ></path>
    </svg>
  );
  return render();
};
